// extracted by mini-css-extract-plugin
export default {"wrapper":"TextContent_wrapper__gG-dS"};